<button
  type="button"
  matButton
  [matButton]="variant()"
  [disabled]="disabled()"
  [style.height.px]="height()"
  [style.line-height.px]="lineHeight()"
  [style.font-size.px]="fontSizeText()"
  [style.--btn-active-color]="resolvedColor()"
  [style.--button-border-color]="resolvedBorderColor()"
  (click)="clicked.emit($event)"
>
  @if (customIconPath(); as path) {
    <img
      [src]="path"
      class="button-custom-icon"
      [style.width.px]="iconSize()"
      [style.height.px]="iconSize()"
      [style.font-size.px]="fontSizeIcon()"
    />
  } @else if (icon()) {
    <mat-icon
      class="button-custom-icon"
      [style.width.px]="iconSize()"
      [style.height.px]="iconSize()"
      [style.font-size.px]="fontSizeIcon()"
      >{{ icon() }}</mat-icon
    >
  }
  <ng-content></ng-content>
</button>

<!-- These are examples of all button variants, which we can directly use in the project -->

<!-- <section class="button-demos">
  <h1>Button variants</h1>

  <h2>Text</h2>
  <div class="row">
    <bi-button (clicked)="onButtonClick()">Text button</bi-button>
  </div>

  <h2>Filled</h2>
  <div class="row">
    <bi-button variant="filled" (clicked)="onButtonClick()">Filled button</bi-button>
  </div>

  <h2>Outlined</h2>
  <div class="row">
    <bi-button variant="outlined" (clicked)="onButtonClick()">Outlined button</bi-button>
  </div>

  <h2>Disabled</h2>
  <div class="row">
    <bi-button [disabled]="true">Disabled text</bi-button>
    <bi-button variant="filled" [disabled]="true">Disabled filled</bi-button>
    <bi-button variant="outlined" [disabled]="true">Disabled outlined</bi-button>
  </div>

  <h2>With icon (left)</h2>
  <div class="row">
    <bi-button icon="add" (clicked)="onButtonClick()">Add</bi-button>
    <bi-button variant="filled" icon="save" (clicked)="onButtonClick()">Save</bi-button>
    <bi-button variant="outlined" icon="edit" (clicked)="onButtonClick()">Edit</bi-button>
  </div>
</section> -->
